/// <reference path="../../app.typings.d.ts" />
'use strict';
var app;
(function (app) {
    var Services;
    (function (Services) {
        var AuthenticationService = /** @class */ (function () {
            function AuthenticationService($cookies, localStorageService, appSettings) {
                this.$cookies = $cookies;
                this.localStorageService = localStorageService;
                this.appSettings = appSettings;
                this._authData = new app.AuthData();
                this.authDataCookieName = 'authorizationData';
                this.wlptDataCookieName = 'WPauthorizationData';
                this.wlptUserCookieName = 'WPuserData';
                this.keys = ap.Constants.localStorageKeys.permissions;
                this.timeOutBufferSeconds = 30;
                var dataCookie = this.getAuthorizationDataFromCookies();
            }
            Object.defineProperty(AuthenticationService.prototype, "authorizationData", {
                get: function () {
                    return this._authData;
                },
                enumerable: true,
                configurable: true
            });
            AuthenticationService.prototype.getAuthorizationDataFromCookies = function () {
                var authCookie = this.$cookies.getObject(this.authDataCookieName);
                if (!ap.Utilities.isNullOrUndefined(authCookie)) {
                    authCookie.FirstName = authCookie.first_name;
                    authCookie.LastName = authCookie.last_name;
                    authCookie.UserName = authCookie.username;
                }
                else if (!ap.Utilities.isNullOrUndefined(this.$cookies.getObject(this.wlptDataCookieName))) {
                    authCookie = this.$cookies.getObject(this.wlptDataCookieName);
                    var userCookie = this.$cookies.getObject(this.wlptUserCookieName);
                    authCookie.FirstName = userCookie.FirstName;
                    authCookie.LastName = userCookie.LastName;
                    authCookie.UserName = userCookie.UserName;
                    authCookie.UserCacheKey = userCookie.UserCacheKey;
                }
                if (!ap.Utilities.isNullOrUndefined(this.$cookies.getObject(this.wlptDataCookieName))) {
                    var wpAuthCookie = this.$cookies.getObject(this.wlptDataCookieName);
                    authCookie.OrganizationUnitCacheKey = wpAuthCookie.OrganizationUnitCacheKey;
                }
                if (!ap.Utilities.isNullOrUndefined(authCookie)) {
                    this._authData.updateAuthData(authCookie);
                }
                if (!this._authData.IsAuth || this._authData.isExpired()) {
                    this.logout();
                    return;
                }
                return authCookie;
            };
            AuthenticationService.prototype.isStale = function (bufferInMinutes) {
                return this._authData.isStale(bufferInMinutes);
            };
            AuthenticationService.prototype.isExpired = function (bufferInMinutes) {
                return this._authData.isExpired(bufferInMinutes);
            };
            AuthenticationService.prototype.logout = function () {
                var preLogin = (ap.Utilities.isNullOrUndefined(this._authData.LoginSystem) || this._authData.LoginSystem.length < 1), logoutURL;
                // If the user comes in from WP, redirect back to WP login
                if (preLogin || this._authData.LoginSystem === 'SSO') {
                    logoutURL = this.appSettings.urls.sso + "/#/logout/?redirect=" + encodeURIComponent(window.location.href) + "&clientId=" + this.appSettings.applicationCacheKey;
                    this.$cookies.remove(this.authDataCookieName);
                }
                else {
                    logoutURL = this.appSettings.urls.wpUrl + "/#/login/WP";
                    this.$cookies.remove(this.wlptDataCookieName);
                    this.$cookies.remove(this.wlptUserCookieName);
                }
                this.localStorageService.deleteAllItems();
                this._authData.updateAuthData();
                window.location.href = logoutURL;
            };
            AuthenticationService.$inject = [
                '$cookies',
                'localStorageService',
                'appSettings'
            ];
            return AuthenticationService;
        }());
        Services.AuthenticationService = AuthenticationService;
        angular.module('app.Services')
            .service('authenticationService', AuthenticationService);
    })(Services = app.Services || (app.Services = {}));
})(app || (app = {}));
